module.exports = "/_next/static/images/btn-e31979f3c15de24164b315c8815f0d87.png";